var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('header',{ref:"header"},[_c('app-header')],1),_c('main',[_c('router-view')],1),_c('footer',{ref:"footer"},[_c('app-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }